import { List, Map, Record } from "immutable";

import { ReferenceType } from "./state/courses/course/references/reference/Reference";
import { SubscriptionTier } from "./state/courses/course/subscriptionTier/SubscriptionTier";
import { TagType } from "./state/courses/course/tags/tag/Tag";

export type CourseDraftType = {
  id?: string;
  courseId?: string;
  name: string;
  description: string;
  authors: List<string>;
  references: List<ReferenceType>;
  tags: Map<string, List<TagType>>;
  headerImageURL: string | null;
  available: boolean;
  darkText: boolean;
  sectionIds: List<string>;
  startingSectionId: string | null | undefined;
  published: boolean | null;
  visible: boolean | null;
  visibility: string | null;
  subscriptionTier: SubscriptionTier | null;
  regions: List<string>;
  lastEdited: string | null;
  lastPublished: string | null;
  textToSpeechEnabled: boolean | undefined;
  vocabularyEnabled: boolean | undefined;
};

const defaultCourseDraft: CourseDraftType = {
  id: undefined,
  courseId: undefined,
  name: "",
  description: "",
  authors: List(),
  references: List(),
  tags: Map<string, List<TagType>>(),
  headerImageURL: null,
  available: false,
  darkText: true,
  sectionIds: List(),
  startingSectionId: null,
  published: null,
  visible: null,
  visibility: null,
  subscriptionTier: null,
  regions: List(),
  lastEdited: null,
  lastPublished: null,
  textToSpeechEnabled: undefined,
  vocabularyEnabled: undefined
};

export default class CourseDraft extends Record(defaultCourseDraft) {}
